import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";

import SearchIcon from "@/inline-assets/search.svg";
import {
  // prepareSearch,
  showSearch,
} from "@/search/actions.mjs";
import Ripple from "@/shared/Ripple.jsx";

const Container = styled("div", forwardRef)`
  isolation: isolate;
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
  height: var(--sp-9);
  padding: 0 var(--sp-3);
  background: var(--shade3-15);
  color: var(--shade2);
  font-size: var(--sp-3_5e);
  border-radius: var(--br-lg);
  box-shadow: var(--highlight);
  cursor: pointer;
  transition: background var(--transition);

  &:hover {
    background: var(--shade3-25);
  }

  /* > :not(svg) {
    transition: opacity var(--transition);
    transition-delay: var(--transition-duration-short);
  } */

  &.collapse {
    max-width: var(--sp-10);
    transition-duration: 0s;
    transition-delay: 0s;
    aspect-ratio: 1;
    > :not(svg) {
      transition-delay: 0s;
      opacity: 0;
    }
  }
  svg {
    flex-shrink: 0;
    width: 1.125rem;
    height: 1.125rem;
  }
  .title {
    line-height: 1.25rem;
    color: var(--shade2);
    min-width: var(--sp-16);
    white-space: nowrap;
  }
`;

const NavSearch = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Container
      // onMouseEnter={prepareSearch}
      onClick={showSearch}
      className="nav-search"
      {...props}
    >
      <SearchIcon />
      <span className="title type-form--button">
        {t("common:search.search", "Search")}
      </span>

      <Ripple />
    </Container>
  );
};

export default NavSearch;
